// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"1307":"FrameAdvisorVideo","1396":"average-head","4238":"VtoCaptureVideo","8083":"ReactJson","8201":"MirrorAsyncRoot","8705":"MirrorContainer"}[chunkId] || chunkId) + ".chunk.js";
};